import { LocaleSettings } from './locale.settings';

export class CurrencyFormatter {

    public static formatCurrency(amount: number = 0, rounding: number = 2): string {
        // Normalize -0 to 0
        if (Object.is(amount, -0)) {
            amount = 0;
        }

        // Ensure rounding is a safe non-negative integer
        if (!Number.isInteger(rounding) || rounding < 0) {
            rounding = 2;
        }

        const currency = new Intl
            .NumberFormat('en', {
                style: 'currency',
                currency: LocaleSettings.currencyUnit,
                maximumFractionDigits: rounding
            })
            .format(amount);

        return currency;
    }
}